import { useContext, useEffect, useState } from 'react';
import SearchInput from "../../components/Filters/SearchInput";
import ReportingDropdown from "../../components/Navigation/BreDropdown";
import SelectADO from "../../components/Filters/SelectADO";
import FiscalYear from "../../components/Filters/FiscalYear";
import Expand from "../../components/Navigation/Expand";
import useFilteredData from "../../hooks/useFilteredData";
import { calculateAvailableYears, calculateYearByType } from "../../utils/helpers";
import { useIframeContext } from '../../context/IframeContext';
import { useAdminContext } from '../../context/AdminContext';
import { useOrganizationContext } from '../../context/OrganizationContext';
import NoResultsMessage from '../../components/Filters/NoResultsMessage';
import AddProjectButton from '../../components/Projects/AddProjectButton';
import ProjectTable from '../../components/Projects/ProjectTable';
import ProjectDataContext from '../../context/ProjectDataContext';
import HomeButton from '../../components/Navigation/HomeButton';
import InteractionDataContext from '../../context/InteractionDataContext';
import { LABELS } from '../../utils/constants';


function Projects() {
    const { isAdmin } = useAdminContext();
    const { isIframe } = useIframeContext();
    const { partnerName } = useOrganizationContext();
    const { setInteractionsYear } = useContext(InteractionDataContext);
    const { projects, fetchProjects } = useContext(ProjectDataContext);

    const [ado, setAdo] = useState('');
    const [year, setYear] = useState('');
    const [sortType, setSortType] = useState('');
    const [searchTerm, setSearchTerm] = useState<string>('');

    const currFisYear = calculateYearByType(year); 
    const availableYears = calculateAvailableYears();
    const { filteredInitiatives } = useFilteredData(undefined, undefined, projects, undefined, searchTerm, sortType, year, undefined, ado);

    const filterState = {
        year,
        ado,
    };
    
    // Save the filter state to localStorage when filters change
    const saveFiltersToLocalStorage = () => {
        localStorage.setItem('initiativeFilters', JSON.stringify(filterState));
    };

    // Load filters from localStorage when the component mounts
    useEffect(() => {
        const savedFilters = JSON.parse(localStorage.getItem('initiativeFilters') || '{}');
        isAdmin ? setAdo(savedFilters.ado || '') : setAdo(partnerName);
        setYear(savedFilters.year || currFisYear.toString());
        setSearchTerm('');
        setSortType(savedFilters.sortType || '');
        fetchProjects();
    }, []);

    const filterByYear = (year: string) => {
        setYear(year);
        setInteractionsYear(year);
        filterState.year = year;
        saveFiltersToLocalStorage();
    };
    
    const filterByAdo = (partner_id: string) => {
        setAdo(partner_id);
        filterState.ado = partner_id;
        saveFiltersToLocalStorage();
    };
    
    const handleSearch = (searchTerm: string) => {
        setSearchTerm(searchTerm);
    };
    
    const handleRemoveFilters = () => {
        setYear(currFisYear.toString());
        setSearchTerm('');
        filterState.year = currFisYear.toString();
        if (isAdmin) {
            filterState.ado = '';
        }
        saveFiltersToLocalStorage();
    };

    return ( 
        <>
            <ReportingDropdown/>
            <div className="px-4 py-0 sm:py-4 md:py-4 lg:py-4">
                <div className="mx-2 my-2 relative">
                    <div className="flex flex-wrap items-end w-full justify-start">
                        <HomeButton/>
                        {isIframe && 
                        <div className="flex sm:mt-0 mt-1 mb-1 absolute md:relative top-0 right-0 md:top-auto md:right-auto md:ml-auto transform md:transform-none">
                            <Expand/>
                        </div>
                        }
                    </div>
                </div>
                <div className="mx-2 my-4 flex flex-wrap relative">
                    <div className='w-5/6 sm:w-auto'>
                        <SearchInput onSearch={handleSearch} isLarge={true}/>
                    </div>
                    {(isAdmin) && // Render SelectADO only if in admin view
                        <SelectADO filterByAdo={filterByAdo} currAdo={ado} isSummary={false}/>
                    }
                    <FiscalYear filterByYear={filterByYear} availableYears={availableYears} currYear={year}/>
                    <AddProjectButton />
                </div>
                
                { year && filteredInitiatives.length > 0 ?
                <div className="mx-2">
                    <ProjectTable data={filteredInitiatives}/>
                </div> :
                <NoResultsMessage 
                    itemName={LABELS.ENTITY_NAME}
                    hasFilters={true}
                    onRemoveFilters={handleRemoveFilters}
                />
                }
            </div>
        </>
    );
}

export default Projects;